<script>
  export default {
    props: {
      field: {required: true},
      item: {},
      name: {type: String, default: 'fld'},
    },
    render (el) {
      var children = [];
      if (this.cell.label) {
        children.push(el('dt', this.cell.label));
      }
      var content = this.cell.function(this.e_item, el, this);
      if (typeof content === "object" && !Array.isArray(content)) {
        content = [content];
      }
      children.push(el('dd', content));
      return el(
        'dl',
        {
          class: 'cell-component cell-format-' + (this.cell.format || '') + ' cell-' + this.name.replace(/\./g, '-'),
        },
        children,
      );
    },
    computed: {
      cell () {
        return this.$fields.entry(this.field, this.name);
      },
      e_item () {
        if (this.name !== 'fld') {
          return this.item;
        }
        switch (typeof this.item) {
          case 'object':
            return this.item;
          case 'string':
          case 'number':
          default:
            return {fld: this.item};
        }
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/helpers/components/display/Cell.vue